/**
 * Generated by orval 🍺
 * Do not edit manually.
 * CommunityCliQ API
 *  ## Authentication
 *
 *   Every request must include an API access token generated in the CommunityCliQ \
 *   application:
 *
 *   ```
 *   Authorization: X-API-TOKEN
 *   ```
 *
 * OpenAPI spec version: V2.X
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type {
  CommandErrorResponse,
  InvitationTokenAuthRequest,
  OnboardingJwtResponse,
} from "../../model";

import { customInstance } from "../../../lib/SpringAxios";
import type { ErrorType } from "../../../lib/SpringAxios";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authenticate an onboarding invitation token and return a session JWT.
 * @summary Authenticate an onboarding invitation token and return a session JWT.
 */
export const onboardingLogin = (
  invitationTokenAuthRequest: InvitationTokenAuthRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<OnboardingJwtResponse>(
    {
      data: invitationTokenAuthRequest,
      headers: { "Content-Type": "application/json" },
      method: "POST",
      signal,
      url: `/api/v2/onboarding/auth/login`,
    },
    options,
  );
};

export const getOnboardingLoginMutationKey = () => ["onboardingLogin"] as const;

export const getOnboardingLoginMutationOptions = <
  TError = ErrorType<CommandErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof onboardingLogin>>,
    TError,
    OnboardingLoginMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof onboardingLogin>>,
  TError,
  OnboardingLoginMutationVariables,
  TContext
> => {
  const mutationKey = getOnboardingLoginMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof onboardingLogin>>,
    OnboardingLoginMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return onboardingLogin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OnboardingLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof onboardingLogin>>
>;
export type OnboardingLoginMutationBody = InvitationTokenAuthRequest;
export type OnboardingLoginMutationError = ErrorType<CommandErrorResponse>;
export type OnboardingLoginMutationVariables = {
  data: InvitationTokenAuthRequest;
};

/**
 * @summary Authenticate an onboarding invitation token and return a session JWT.
 */
export const useOnboardingLogin = <
  TError = ErrorType<CommandErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof onboardingLogin>>,
      TError,
      OnboardingLoginMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof onboardingLogin>>,
  TError,
  OnboardingLoginMutationVariables,
  TContext
> => {
  return useMutation(getOnboardingLoginMutationOptions(options), queryClient);
};
